module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/payroll/stepTwo/MTDTooltip.ejs -->\n';
 /*
This template sucks ass and I'm aware. It was originally a Quick&Dirty proof
of concept that admins liked and requested changes to it to be deployed ASAP.

This content shouldn't even be a tooltip to begin with.
*/ 
__p+='\n';
 var Decimal = require('decimal.js'); 
__p+='\n<h4>Calculation Parameters:</h4>\n\n';
 if (data && data.regularIncome) { 
__p+='\n    <h5>Regular Income:</h5>\n\n    <pre>\nChargeable Income (P) =\n(('+
((__t=( (data.taxableYtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.ytdEpf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
') +\n('+
((__t=( (data.taxableRegular || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.regularEpf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
') +\n('+
((__t=( (data.taxableEstimate || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.estimateEpf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
')) -\n'+
((__t=( (data.totalTaxDeduction || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n\nChargeable Income (P) = '+
((__t=( data.regularIncome.chargeable ))==null?'':_.escape(__t))+
'\n    </pre>\n\n    <pre>\nAnnual Tax = (('+
((__t=( (data.regularIncome.chargeable || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.regularIncome.firstChargeableIncome || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
') *\n'+
((__t=( (data.regularIncome.taxRate || 0).format('0,0.000') ))==null?'':_.escape(__t))+
') + ('+
((__t=( (data.regularIncome.taxesOnFirstChargeableIncome || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
')\n\nAnnual Tax = '+
((__t=( (data.regularIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n    </pre>\n';
 } 
__p+='\n\n';
 if (data && data.additionalIncome) { 
__p+='\n    <h5>Additional Income:</h5>\n\n    <pre>\nChargeable Income (P\') = (('+
((__t=( (data.taxableYtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.ytdEpf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
') +\n('+
((__t=( (data.taxableAdditional || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.epf || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
') +\n('+
((__t=( (data.taxableEstimate || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.estimateEpfAdditional || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
')) -\n'+
((__t=( (data.totalTaxDeduction || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n\nChargeable Income (P\') = '+
((__t=( data.additionalIncome.chargeable ))==null?'':_.escape(__t))+
'\n    </pre>\n\n    <pre>\nMTD\'(PCB\') = (('+
((__t=( (data.additionalIncome.chargeable || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.additionalIncome.firstChargeableIncome || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
') *\n'+
((__t=( (data.additionalIncome.taxRate || 0).format('0,0.000') ))==null?'':_.escape(__t))+
') + ('+
((__t=( (data.additionalIncome.taxesOnFirstChargeableIncome || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
')\nMTD\'(PCB\') = '+
((__t=( (data.additionalIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n\nMTD\'\'(PCB\'\') = (('+
((__t=( (data.regularIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.ytdMtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' -\n'+
((__t=( (data.ytdZakat || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
') / (13 - '+
((__t=( (data.month || 0) ))==null?'':_.escape(__t))+
')) - '+
((__t=( (data.totalZakat || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\nMTD\'\'(PCB\'\') = '+
((__t=( (data.regularIncome.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' (0 if number was less than 10)\n\nMTD(PCB) = MTD\'\'(PCB\'\') + '+
((__t=( (data.additionalIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'  -\n('+
((__t=( (data.ytdMtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' + ('+
((__t=( (data.regularIncome.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' * (13 - '+
((__t=( (data.month || 0) ))==null?'':_.escape(__t))+
'))\n\nMTD(PCB) = '+
((__t=( (data.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' (Number rounded to spec)\n    </pre>\n\n';
 } else if (data.regularIncome) { 
__p+='\n    <pre>\nMTD(PCB) = (('+
((__t=( (data.regularIncome.annual || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' - '+
((__t=( (data.ytdMtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' -\n'+
((__t=( (data.ytdZakat || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
') / (13 - '+
((__t=( (data.month || 0) ))==null?'':_.escape(__t))+
')) - '+
((__t=( (data.totalZakat || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n\nMTD(PCB) = '+
((__t=( (data.mtd || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
' (Number rounded to spec)\n    </pre>\n';
 } 
__p+='\n\n';
 if (data && data.totalTaxDeduction) { 
__p+='\n    <h4>Deductions applied:</h4>\n    <pre>\nTotal: '+
((__t=( (data.totalTaxDeduction || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n    </pre>\n';
 } 
__p+='\n\n';
 if (data && data.compulsoryDeductions) { 
__p+='\n    <h5>Compulsory</h5>\n    <ul>\n        <li>Individual: RM '+
((__t=( data.compulsoryDeductions.individual ))==null?'':_.escape(__t))+
'</li>\n        <li>Disability: RM '+
((__t=( data.compulsoryDeductions.isDisabled ))==null?'':_.escape(__t))+
'</li>\n        <li>Spouse: RM '+
((__t=( data.compulsoryDeductions.spouse ))==null?'':_.escape(__t))+
'</li>\n        <li>Spouse disability: RM '+
((__t=( data.compulsoryDeductions.spouseIsDisabled ))==null?'':_.escape(__t))+
'</li>\n        <li>\n            Children:\n            <ul>\n                <li>Underage: RM '+
((__t=( data.compulsoryDeductions.child.underage ))==null?'':_.escape(__t))+
'</li>\n                <li>Disabled: RM '+
((__t=( data.compulsoryDeductions.child.disabled ))==null?'':_.escape(__t))+
'</li>\n                <li>In education: RM '+
((__t=( data.compulsoryDeductions.child.inEducation ))==null?'':_.escape(__t))+
'</li>\n                <li>In education+: RM '+
((__t=( data.compulsoryDeductions.child.inHigherEducation ))==null?'':_.escape(__t))+
'</li>\n                <li>In education++: RM '+
((__t=( data.compulsoryDeductions.child.disabledInEducation ))==null?'':_.escape(__t))+
'</li>\n            </ul>\n        </li>\n    </ul>\n';
 } 
__p+='\n\n';
 if (data && data.taxDeductions) { 
__p+='\n    <h5>Others</h5>\n    <ul>\n        ';
 if (data.taxDeductions.length === 0) { 
__p+='\n            <li>No additional tax deductions</li>\n        ';
 } else { 
__p+='\n            ';
 data.taxDeductions.forEach(function (deduction) { 
__p+='\n                <li>\n                    '+
((__t=( deduction.name ))==null?'':_.escape(__t))+
':\n                    RM '+
((__t=( new Decimal(deduction.amount).minus(deduction.ytd || 0).toDP(2, Decimal.ROUND_HALF_UP).toNumber() ))==null?'':_.escape(__t))+
'\n                    (Y: RM '+
((__t=( deduction.ytd ))==null?'':_.escape(__t))+
')\n                </li>\n            ';
 }) 
__p+='\n        ';
 } 
__p+='\n    </ul>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/payroll/stepTwo/MTDTooltip.ejs
// module id = 746
// module chunks = 1